export default {
  getRoutesList: '/api/routes/getRoutesList', //获取菜单列表
  getRoleMenuList: '/api/routes/getRoleMenuList', //获取已选中的菜单列表
  getRoleList: '/api/role/getRoleList', // 获取角色列表
  editRole: '/api/role/editRole', //修改角色
  addRole: '/api/role/addRole', //新增角色
  delRole: '/api/role/delRole', //删除角色

  getRoleDetail: '/api/role/getRoleDetail', // 获取角色详情
};
